import React from 'react';
import { Filter, AlertTriangle, Bell, Info, CheckCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const PriorityFilterSidebar = ({ filters, onFilterChange, stats }) => {
  const severityOptions = [
    { value: 'critical', label: 'Critical', icon: AlertTriangle, color: 'red' },
    { value: 'high', label: 'High', icon: AlertTriangle, color: 'orange' },
    { value: 'medium', label: 'Medium', icon: Bell, color: 'yellow' },
    { value: 'low', label: 'Low', icon: Info, color: 'blue' }
  ];

  const typeOptions = [
    { value: 'audit', label: 'Audit Events', color: 'purple' },
    { value: 'compliance', label: 'Compliance Warnings', color: 'yellow' },
    { value: 'environmental', label: 'AI Anomalies', color: 'green' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <Filter className="w-5 h-5 text-gray-600" />
          <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
        </div>
      </div>

      {/* Severity Filters */}
      <div className="p-4 border-b border-gray-200">
        <h4 className="text-sm font-medium text-gray-700 mb-3">Priority Level</h4>
        <div className="space-y-2">
          {severityOptions?.map(option => {
            const Icon = option?.icon;
            const isActive = filters?.severity === option?.value;
            
            return (
              <button
                key={option?.value}
                onClick={() => onFilterChange('severity', option?.value)}
                className={`w-full flex items-center justify-between p-3 rounded-lg border transition-all ${
                  isActive
                    ? `bg-${option?.color}-50 border-${option?.color}-300 shadow-sm`
                    : 'bg-white border-gray-200 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon className={`w-4 h-4 ${
                    isActive ? `text-${option?.color}-600` : 'text-gray-500'
                  }`} />
                  <span className={`text-sm font-medium ${
                    isActive ? `text-${option?.color}-900` : 'text-gray-700'
                  }`}>
                    {option?.label}
                  </span>
                </div>
                {isActive && (
                  <CheckCircle className={`w-4 h-4 text-${option?.color}-600`} />
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Alert Type Filters */}
      <div className="p-4 border-b border-gray-200">
        <h4 className="text-sm font-medium text-gray-700 mb-3">Alert Type</h4>
        <div className="space-y-2">
          {typeOptions?.map(option => {
            const isActive = filters?.type === option?.value;
            
            return (
              <button
                key={option?.value}
                onClick={() => onFilterChange('type', option?.value)}
                className={`w-full flex items-center justify-between p-3 rounded-lg border transition-all ${
                  isActive
                    ? `bg-${option?.color}-50 border-${option?.color}-300 shadow-sm`
                    : 'bg-white border-gray-200 hover:bg-gray-50'
                }`}
              >
                <span className={`text-sm font-medium ${
                  isActive ? `text-${option?.color}-900` : 'text-gray-700'
                }`}>
                  {option?.label}
                </span>
                {isActive && (
                  <CheckCircle className={`w-4 h-4 text-${option?.color}-600`} />
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Show Acknowledged Toggle */}
      <div className="p-4">
        <label className="flex items-center justify-between cursor-pointer">
          <span className="text-sm font-medium text-gray-700">Show Acknowledged</span>
          <div className="relative">
            <input
              type="checkbox"
              checked={filters?.showAcknowledged}
              onChange={(e) => onFilterChange('showAcknowledged', e?.target?.checked)}
              className="sr-only"
            />
            <div className={`w-11 h-6 rounded-full transition-colors ${
              filters?.showAcknowledged ? 'bg-green-500' : 'bg-gray-300'
            }`}>
              <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-transform ${
                filters?.showAcknowledged ? 'transform translate-x-5' : ''
              }`} />
            </div>
          </div>
        </label>
      </div>

      {/* Time-based Sorting (Future Enhancement) */}
      <div className="p-4 border-t border-gray-200 bg-gray-50">
        <h4 className="text-sm font-medium text-gray-700 mb-2">Sort By</h4>
        <select 
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          defaultValue="newest"
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="priority">Priority</option>
        </select>
      </div>
    </div>
  );
};

export default PriorityFilterSidebar;